import React, { MouseEvent } from 'react';

export const MAIN_CONTENT_ID = 'main-content';

const focusableElementSelector = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
  '[contenteditable="true"]'
].join(', ');

const getMainContent = () => document.getElementById(MAIN_CONTENT_ID);

export const hasFocusInsideMainContent = () => {
  const activeElement = document.activeElement;
  const mainContent = getMainContent();

  if (!(activeElement instanceof HTMLElement) || mainContent == null) return false;

  return mainContent.contains(activeElement);
};

export const focusMainContent = () => {
  const mainContent = getMainContent();

  if (mainContent == null) return;

  const firstFocusableElement = mainContent.querySelector<HTMLElement>(focusableElementSelector);

  if (firstFocusableElement != null) {
    firstFocusableElement.focus();
    return;
  }

  mainContent.focus();
};

const handleSkipToMainContent = (event: MouseEvent<HTMLAnchorElement>) => {
  event.preventDefault();
  focusMainContent();
};

export const SkipToMainContent = () => (
  <a className="skip-link" href={`#${MAIN_CONTENT_ID}`} onClick={handleSkipToMainContent}>
    Skip to main content
  </a>
);
